import { ConfigService } from './../settings/config.service';
import { AudioSource } from './../shared/model/audio-source.interface';
import { SingleDropboxData, SingleDropboxComponent } from './../shared/single-dropbox/single-dropbox.component';
import { StationSource } from './../core/models/station-source';
import { MergedStation } from './../shared/model/merged-station.interface';
import { StationService } from './../core/services/station.service';
import { SiaWavesurfer } from './../shared/sia-wavesurfer/model/sia-wavesurfer.interface';
import { SegmentAudioInterface } from './../shared/model/segment-audio.interface';
import { FeatureEnum } from './../core/properties/feature.enum';
import { FeatureToggleService } from './../core/services/feature-toggle.service';
import { environment } from './../../environments/environment';
import { TimezoneUtilsService } from './../shared/utils/timezone-utils.service';
import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { chain, cloneDeep, range } from 'lodash';
import * as moment from 'moment-timezone';
import { FlatpickrOptions, Ng2FlatpickrComponent } from 'ng2-flatpickr';
import { BehaviorSubject, forkJoin, interval, Observable, Subject, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { Station } from '../core/models/station';
import { SearchFiltersService } from '../search-filters/search-filters.service';
import { DownloadService } from './../downloads/download.service';
import { DownloadMethodEnum } from './../downloads/model/download-method-enum';
import { ProfileModelService } from './../profile/profile-model.service';
import { StationUtilsService } from './../shared/utils/station-utils.service';
import { ConfirmationDialogComponent } from './linear-playout-table/confirmation-dialog/confirmation-dialog.component';
import { LinearPlayoutService } from './linear-playout.service';
import { DownloadDialogModel } from './models/download-dialog-model.interface';
import { DownloadPlayout, StartAndEndDate } from './models/download-playout.interface';
import { LinearPlayoutRequest } from './models/linear-playout-request.interface';
import { MarketGroup } from './models/market-group.interface';
import { MetadataResponse } from './models/metadata-response.interface';
import { DownloadResponse } from '../downloads/model/download-reponse.interface';
import { ToastService } from '@ihm-software/ihm-ui-common-angular-10';
import { IRegionPositionsAndDuration } from '../shared/waveform/model/region-positions-and-duration.interface';
import { TabIndex } from './models/tab-index.interface';
import { AudioSizeEnum } from '../shared/model/audio-size.enum';

const confirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');


@Component({
  selector: 'app-linear-playout',
  templateUrl: './linear-playout.component.html',
  styleUrls: ['./linear-playout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfigService]
})
export class LinearPlayoutComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('stationSourceMulti', { static: true })
  stationSourceMulti: SingleDropboxComponent;

  tableDataList: BehaviorSubject<MetadataResponse[]> = new BehaviorSubject<MetadataResponse[]>([]);
  dataTable: [];

  stationSoundPlus: any;
  stationMM: any;
  isDisabled = true;

  @ViewChild('startPicker')
  pickerStart: Ng2FlatpickrComponent;
  dateCtrl = new FormControl(null);
  startOptions: FlatpickrOptions = {
    defaultDate: new Date(),
    mode: 'single',
    dateFormat: 'm/d/Y',
    maxDate: new Date(),
    plugins: [new confirmDatePlugin({ showAlways: true })]
  };

  tabs: Array<any>;
  isChanged = false;
  selectedTab: TabIndex = { currentTabIndex: 0, index: 1 };

  // Stations
  stations: Station[] = [];
  marketGroups: MarketGroup[] = [];
  marketGroupOptions: Observable<MarketGroup[]>;
  stationGroupCtrl = new FormControl(null, [
    Validators.required,
    this.autoCompleteValidator()
  ]);
  stationTimeZone = '';

  // Sources
  stationSources: SingleDropboxData[] = [];
  stationSourceSelected: SingleDropboxData;
  isStationSourcesDropboxDisable = true;

  showWaveformComponent = false;
  regionsSubject: BehaviorSubject<IRegionPositionsAndDuration> = new BehaviorSubject<IRegionPositionsAndDuration>(null);
  regionsOfDates: BehaviorSubject<StartAndEndDate> = new BehaviorSubject<StartAndEndDate>(null);
  messageNoAudio: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  urlAudioSubject: Subject<any> = new Subject<any>();
  disableAllDownloadButton: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  clearRegion: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  finishDownload: Subject<any> = new Subject<any>();
  listDownload: Subject<any> = new Subject<any>();
  arrayLineClicked = [];
  srcAudioListAudio;

  startTime;
  endTime;
  s3Lifecycle;
  showSetInterval = true;
  isDownloadButtonDisabled = true;
  formLinearPlayout: FormGroup;
  stationSelectedModel: Station;
  tableSelectedLines: AudioSource[] = [];
  streamUrl: SiaWavesurfer;
  audioReady = false;
  isTableEvent = false;

  private submitStartTime: string;
  private submitEndTime: string;
  private bodyTable: LinearPlayoutRequest;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private readonly ERROR_METADATA_MESSAGE = 'Error getting metadata';
  private readonly ERROR_PLAYOUT_MESSAGE = 'Error getting playout';
  private readonly MESSAGE_AUDIO_BEING_GENERATED = 'The Audio is being generated in the background. This can take a few minutes';
  public readonly MESSAGE_NO_AUDIO_AVAILABLE = 'No Audio Available';
  public readonly MESSAGE_AUDIO_NOT_FOUND = 'Audio not found';
  public readonly MESSAGE_STREAM_ERROR = 'an error occurred while trying to load the audio streams';
  messageNoAudioAvailable = 'No Audio Available';

  constructor(
    private readonly searchFiltersService: SearchFiltersService,
    private readonly stationUtilsService: StationUtilsService,
    private readonly linearPlayoutService: LinearPlayoutService,
    private dialog: MatDialog,
    private downloadService: DownloadService,
    private profileModelService: ProfileModelService,
    private timezoneUtilsService: TimezoneUtilsService,
    private readonly toastServiceToast: ToastService,
    private featureToggleService: FeatureToggleService,
    private stationService: StationService,
    private configService: ConfigService,
  ) {
    const arrayHours: number[] = range(24);
    this.tabs = arrayHours.map((value: number) => {
      return {
        title: value < 10 ? '0' + value : value.toString()
      };
    });
  }


  ngOnInit() {
    this.initializeForm();

    this.selectedTab.currentTabIndex = new Date().getHours() - 1;
    this.selectedTab.index = new Date().getHours() - 1;
    this.dateCtrl.setValue(new Date());

    this.getAllStations();
    this.subscribes();
    this.setStationSources(null); // Clear source options
    this.hideWaveSurfer();


    if (this.showSetInterval) {
      interval(30000)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.loadDownload();
        });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.configService.findLifecycle()
    .subscribe((config) =>{
       this.pickerStart.flatpickr['config'].minDate = moment().subtract(config.value, 'days').toDate();
       this.s3Lifecycle = config.value;
      });
  }

  getMarketGroupOptions(): Observable<MarketGroup[]> {
    return this.stationGroupCtrl.valueChanges.pipe(
      startWith(''),
      map((value: string | MergedStation) => {
        if (typeof value === 'string') {
          return this._filterMarketGroupsByStationName(value);
        } else {
          return this._filterMarketGroupsByStationName(value.name);
        }
      })
    );
  }

  displayStation(stationGroup: MergedStation): string {
    return stationGroup ? `${stationGroup.name}` : '';
  }

  getAllStations() {
    this.searchFiltersService.loadAllStationsNoCache().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (stations) => {
        this.stations = stations;
        this.marketGroups = this.sortMarketGroups(
          this.groupStationsByMarket(stations)
        );
        this.marketGroupOptions = this.getMarketGroupOptions();
      },
      (error) => {
        this.stations = [];
      }
    );
  }

  groupStationsByMarket(stations: Station[]): MarketGroup[] {
    return (
      chain(stations)
        // Group the stations of Array based on `market` property
        .groupBy('market')
        // `key` is group's name (market), `value` is the array of stations
        .map((value: Station[], key: string) => {
          const stationGroups: MergedStation[] = this.stationService.groupStationByName(value);
          const marketGroup: MarketGroup = { name: key, mergedStations: stationGroups };
          return marketGroup;
        })
        .value()
    );
  }

  onTabChange(tab: Partial<MatTabChangeEvent>) {
    this.selectedTab.currentTabIndex = tab.index;
    this.selectedTab.index = tab.index;
    this.resetValues();

  }

  getSelectedIndex(): number {
    return this.selectedTab.currentTabIndex;
  }

  selectStation(mergedStation: MergedStation) {
    this.stationGroupCtrl.setValue(mergedStation);
    this.stationTimeZone = mergedStation.timeZone;
    this.setStationSources(mergedStation.stationSources);
  }

  public selectStationSource(event: SingleDropboxData) {
    this.stationSourceSelected = event;
    this.getDataLinearPlayout();
  }

  setStationSources(stationSources: StationSource[]) {
    // Always clear selected source when changing station
    if (stationSources) {
      this.stationSources = stationSources.map(source => {
        return {
          id: source.id,
          name: source.name,
          model: source
        };
      });
      const defaultStationSource = this.profileModelService.getDefaultStationSource();
      this.isStationSourcesDropboxDisable = true;
      this.stationSourceMulti.setList(this.stationSources);

      if (this.stationSources && this.stationSources.length > 1) {
        this.isStationSourcesDropboxDisable = false;
      }

      if (this.stationSources.length === 1){
        this.stationSourceSelected = this.stationSources[0];
      }

      if (defaultStationSource) {
        if (this.stationSources.find(source => source.id == defaultStationSource.id)){
          this.stationSourceSelected = {
            id: defaultStationSource.id,
            model: defaultStationSource,
            name: defaultStationSource.name
          };
        }
      }

      this.selectStationSource(this.stationSourceSelected);
    } else {
      this.stationSourceSelected = null;
      this.stationSources = null;
      this.isStationSourcesDropboxDisable = true;
    }
  }

  waveSelectionDownload() {
    const dialogWave = this.createDialog();
    dialogWave.afterClosed().subscribe((result: DownloadDialogModel) => {

      if (!result) {
        return;
      }
      const body = this.mapperBodyDownload(result, this.submitStartTime, this.submitEndTime);
      
      this.linearPlayoutService
        .downloadItem(body)
        .then(() => {
          if (result.deliveryMethodType === DownloadMethodEnum.EMAIL) {
            this.toastServiceToast.openSnackBar('File is being generated. Once completed you will receive an e-mail.', 'Ok');
            return;
          }
          this.toastServiceToast.openSnackBar('File is being generated. Check the audio on the Downloads page.', 'Ok');
        },
          error => {
            this.toastServiceToast.openSnackBar('Error while generating the file.', 'Ok');
          });
    });
  }

  callbackDownload(callbackDownload: AudioSource) {

    if (!this.formLinearPlayout.valid) {
      this.finishDownload.next(callbackDownload);
      this.formLinearPlayout.markAsTouched();
      return;
    }

    const dialogRef = this.createDialog(callbackDownload.linkDownload);

    dialogRef.afterClosed().subscribe((result: DownloadDialogModel) => {

      if (!result) {
        this.finishDownload.next(callbackDownload);
        return;
      }
      callbackDownload.isLoading = true;

      if (callbackDownload?.linkDownload?.length) {
        callbackDownload.isTwoAudio = true;
      }

      const body = this.mapperBodyDownload(result, callbackDownload.startTime, callbackDownload.endTime);

      this.linearPlayoutService.downloadItem(body).then((resp: AudioSource) => {
        if (result.deliveryMethodType === DownloadMethodEnum.EMAIL) {
          callbackDownload.isLoading = false;
          this.finishDownload.next(callbackDownload);
        }
      },
        error => {
          this.toastServiceToast.openSnackBar(this.MESSAGE_AUDIO_NOT_FOUND, 'Ok');
          callbackDownload.isLoading = false;

          this.finishDownload.next(callbackDownload);
        });
    });
  }

  clearStation() {
    this.stationGroupCtrl.setValue('');
    this.setStationSources(null); // Clear source options
    this.stationSelectedModel = null;
    this.stationTimeZone = '';
  }

  sourceSelected() {
    this.getDataLinearPlayout();
  }

  onPreviousHour(call: boolean) {
    if (call) {
      this.onTabChange({ index: this.selectedTab.currentTabIndex - 1 });
    }
  }

  onNextHour(call: boolean) {
    if (call) {
      this.onTabChange({ index: this.selectedTab.currentTabIndex + 1 });
    }
  }

  onClearSelection() {
    this.changeStartAndEndTime(0, 0);
  }

  selectedLines(selectedRows: AudioSource[]) {
    this.isTableEvent = true;
    this.tableSelectedLines = selectedRows;
    if (selectedRows.length === 0) {
      this.clearRegion.next(true);
      return;
    }
    this.calculateRegions(selectedRows);
  }

  regionChanged(region: IRegionPositionsAndDuration) {
    if (this.isTableEvent) {
      this.isTableEvent = false;
      return;
    }

    this.changeStartAndEndTime(region.start, region.end);
  }

  loadWaveAudio() {
    this.linearPlayoutService.getAudioLinearPlayout(this.bodyTable)
      .pipe(map((res) => res), catchError(e => of(this.ERROR_PLAYOUT_MESSAGE))).subscribe(response => {
        this.handlePlayoutResponse(response);

      });
  }

  audioReadyToListening(value) {
    this.audioReady = value;
    this.showWaveformComponent = true;
    this.isDownloadButtonDisabled = false;
  }

  private resetValues() {
    this.urlAudioSubject.next(true);
    this.getDataLinearPlayout();
    this.audioReady = false;
    this.streamUrl = null;
    this.hideWaveSurfer();
  }

  private calculateRegions(audioSourceList: AudioSource[]) {
    let startTime;
    let endTime;
    if (audioSourceList.length) {
      audioSourceList.forEach(item => {
        const start = moment(item.startTime.replace('Z', ''));
        const end = moment(item.endTime.replace('Z', ''));
        if (startTime == null || start.isBefore(startTime)) {
          startTime = start;
        }
        if (endTime == null || end.isAfter(endTime)) {
          endTime = end;
        }
      });
    }

    const start = startTime != null ? moment.duration(startTime.format('00:mm:ss')).asSeconds() : 0;
    const end = endTime != null ? moment.duration(endTime.format('00:mm:ss')).asSeconds() : 3600;

    const formatDate = this.formatDateControlValue();
    const selectTabIndex = this.selectedTab.currentTabIndex;
    this.changeSubmitStarAndEndTime(formatDate, selectTabIndex, start, end);

    this.regionsSubject.next({ start, end });
  }

  private autoCompleteValidator(): ValidatorFn {
    return (ctrl: AbstractControl) => {
      if (typeof ctrl.value === 'string') {
        return ctrl;
      }
      return null;
    };
  }

  private subscribes() {
    this.dateCtrl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value != null) {
        this.resetValues();
      }
    });
  }

  private changeStartAndEndTime(start: number, end: number) {
    if (start === 0 && end === 0) {
      this.regionsOfDates.next(null);
      return;
    }
    const formatDate = this.formatDateControlValue();
    const selectTabIndex = this.selectedTab.currentTabIndex;

    this.changeSubmitStarAndEndTime(formatDate, selectTabIndex, start, end);
    this.regionsOfDates.next({ startDateTime: this.submitStartTime, endDateTime: this.submitEndTime });
  }

  private formatDateControlValue() {
    return moment(this.dateCtrl.value.length ? this.dateCtrl.value[0] : this.dateCtrl.value).format('YYYY-MM-DD');
  }

  private changeSubmitStarAndEndTime(formatDate: string, selectTabIndex: any, start: number, end: number) {
    this.submitStartTime = this.toZuluStationTimezone(
      this.formatDateGetDataTable(formatDate, selectTabIndex, null, start));
    this.submitEndTime = this.toZuluStationTimezone(
      this.formatDateGetDataTable(formatDate, selectTabIndex, null, end === 3600 ? AudioSizeEnum.ONE_HOUR : end)
    );
  }

  private getDataLinearPlayout() {
    this.bodyTable = null;
    this.tableDataList.next([]);
    this.urlAudioSubject.next(true);
    this.clearRegion.next(true);
    this.stationSelectedModel = this.getStationToDownload();
    if (this.formLinearPlayout.valid && this.stationSelectedModel != null) {

      this.loading.next(true);
      this.bodyTable = this.mapperBodyToGetDataTable();

      this.stationService.findStation(this.stationSelectedModel.id)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe((result: Station) => {
          if (result.enterpriseStationId != null) {
            this.bodyTable.esId = result.enterpriseStationId;
            this.linearPlayoutService.cancelSegmentRequest();

            forkJoin([
              this.linearPlayoutService.getDataTableLinearPlayout(this.bodyTable)
                .pipe(map((res) => res), catchError(e => of(this.ERROR_METADATA_MESSAGE))),
              this.linearPlayoutService.getSegmentsAudiosStation(this.bodyTable)
                .pipe(map((res) => res), catchError(e => of(this.ERROR_PLAYOUT_MESSAGE)))
            ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (response: [MetadataResponse[] | string, DownloadResponse | string | SegmentAudioInterface]) => {
                this.loading.next(false);
                this.loadDownload();

                this.handleMetadataResponse(response[0], response[1]);
                this.handlePlayoutResponse(response[1]);

              });
          }
        });
    }
  }

  private handleMetadataResponse(metadataResponse: MetadataResponse[] | string,
    playoutMessage: DownloadResponse | string | SegmentAudioInterface) {
    if (metadataResponse === this.ERROR_METADATA_MESSAGE || metadataResponse.length === 0) {
      const messagePlayout = playoutMessage !== this.ERROR_PLAYOUT_MESSAGE
        && (playoutMessage as DownloadResponse).downloadLink != null ? 'Only audio available' : '';
      this.toastServiceToast.openSnackBar(`No Metadata available ${messagePlayout}`, 'Ok');
      this.tableDataList.next([]);
      return;
    }
    const data = metadataResponse as MetadataResponse[];
    const newData = cloneDeep(data.map(station => {
      station.stationId = this.getStationToDownload().id;
      station.airTime = moment(station.airTime).tz(this.getStationToDownload().timeZone).format('HH:mm:ss');
      return station;
    }));
    this.tableDataList.next(newData);

  }

  private handlePlayoutResponse(playoutMessage: DownloadResponse | string | SegmentAudioInterface) {

    const isAudioSegmentToggleEnabled = this.featureToggleService.isEnabled(
      FeatureEnum.isAudioSegmentToggleEnabled
    );

    if (playoutMessage === this.ERROR_PLAYOUT_MESSAGE) {
      this.isDownloadButtonDisabled = true;
      if (playoutMessage === this.ERROR_PLAYOUT_MESSAGE) {
        this.disableAllDownloadButton.next(true);
      }

      this.hideWaveSurfer();

      this.toastServiceToast.openSnackBar(this.MESSAGE_NO_AUDIO_AVAILABLE, 'Ok');
      return;
    }


    if (isAudioSegmentToggleEnabled) {
      this.onPreviewPressed(playoutMessage as SegmentAudioInterface);

    } else {
      this.streamUrl.url = (playoutMessage as DownloadResponse).downloadLink;
    }

    this.changeSubmitStarAndEndTime(this.formatDateControlValue(), this.selectedTab.currentTabIndex, 0, 3599);
  }

  private toZuluStationTimezone(dateTime: moment.Moment): string {
    const selectedStation = this.getStationToDownload();
    return this.timezoneUtilsService.getISOStringTimezone(dateTime, selectedStation?.timeZone);
  }

  private mapperBodyToGetDataTable(): LinearPlayoutRequest {
    const selectedDate = this.dateCtrl.value.length ? this.dateCtrl.value[0] : this.dateCtrl.value;
    
    //Adding DST extra hour to the linear-playout table and sorted it to put next to "01" Hrs
    const dstExtraHrTitle = {
      title: "01",
    }
    if(this.timezoneUtilsService.isDSTEndDate(new Date(this.dateCtrl.value))) { 
      if(this.tabs.filter((currentElement) => currentElement.title == '01').length < 2) { 
        this.tabs.push(dstExtraHrTitle);
        this.tabs.sort((p1, p2) => (p1.title > p2.title) ? 1 : (p1.title < p2.title) ? -1 : 0);
        
      }

    }
    else{

      if(this.tabs.filter((currentElement) => currentElement.title == '01').length == 2) { 
        this.tabs.splice(2,1) 
      }
    };
    
    // Converts to GMT-0 based on station timezone
    const startTime = this.formatDateGetDataTable(moment(selectedDate).format('YYYY-MM-DD'), this.selectedTab.currentTabIndex);
    const endTime = this.formatDateGetDataTable(moment(selectedDate).format('YYYY-MM-DD'), this.selectedTab.currentTabIndex, 59, 59);

    return {
      stationId: this.getStationToDownload().id,
      startTime: this.toZuluStationTimezone(startTime),
      endTime: this.toZuluStationTimezone(endTime)
    };
  }

  private formatDateGetDataTable(date, hour, minutes = 0, seconds = 0): moment.Moment {  
    const isCurrentTimeDST = moment(date).add(hour,'hours').isDST()
    const isCurrentDayDST = moment(date).isDST()
    const previousHour = moment(date).add(hour-1, 'hours').add(minutes, 'minutes').add(seconds, 'seconds');
    const currentHour = moment(date).add(hour, 'hours').add(minutes, 'minutes').add(seconds, 'seconds');    
    return (isCurrentTimeDST && !isCurrentDayDST) ? previousHour :  currentHour 
  }

  private _filterMarketGroupsByStationName(value: string): MarketGroup[] {
    if (value && value !== '') {
      return this.marketGroups
        .map((marketGroup) => ({
          name: marketGroup.name,
          mergedStations: this.filterStationGroupsByName(
            marketGroup.mergedStations,
            value
          )
        }))
        .filter((marketGroup) => marketGroup.mergedStations.length > 0);
    }
    return this.marketGroups;
  }

  private filterStationGroupsByName(
    mergedStations: MergedStation[],
    value: string
  ): MergedStation[] {
    const filterValue = value.toLowerCase();
    return mergedStations.filter((station) =>
      `${station.name}`.toLowerCase().includes(filterValue)
    );
  }

  private sortMarketGroups(marketGroups: MarketGroup[]) {
    return marketGroups.sort((m1, m2) => m1.name.localeCompare(m2.name));
  }

  private getStationToDownload(): Station {
    const mergedStationSelected: MergedStation = this.stationGroupCtrl.value;
    const stationId = mergedStationSelected.mapStationSources.get(this.stationSourceSelected.id);
    return mergedStationSelected.model.find((station) => station.id === stationId);
  }

  private initializeForm(): void {
    this.formLinearPlayout = new FormGroup({
      station: this.stationGroupCtrl,
      date: this.dateCtrl
    });
  }

  private loadDownload() {
    this.downloadService
      .getDownloads(this.profileModelService.getProfile().token)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response) => {

        this.listDownload.next(response);
      });
  }

  private mapperBodyDownload(result: DownloadDialogModel, starDate: string, endDate: string): DownloadPlayout {
    const startDateTime = this.timezoneUtilsService.subtractSecondsToDate(starDate, environment.downloadPaddingInSeconds);
    const endDateTime = this.timezoneUtilsService.addSecondsToDate(endDate, environment.downloadPaddingInSeconds);

    return {
      deliveryMethodType: result.deliveryMethodType
      , format: result.formatType
      , userId: result.email
      , downloadType: result.downloadOption
      , startDateTime
      , endDateTime
      , stationId: this.getStationToDownload().id
    };
  }

  private createDialog(linksDownload?: string[]): MatDialogRef<ConfirmationDialogComponent> {
    return this.dialog.open(ConfirmationDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: { linksDownload }
    });
  }

  async onPreviewPressed(response?: SegmentAudioInterface): Promise<void> {
    this.streamUrl = null;
    if (response != null) {
      try {
        this.audioReady = false;

        if (response.audioUrls.length) {
          const promiseArray = response.audioUrls.map(async (url) => {
            return await this.downloadBlobFile(url);
          });

          const arrayJob = await Promise.all(promiseArray);
          this.streamUrl = {
            url: new Blob(arrayJob as BlobPart[], { type: 'audio/mp3' }),
            markerStartPosition: response.startTimeInSeconds,
            markerEndPosition: response.startTimeInSeconds + AudioSizeEnum.SIXTY_MINUTES
          };
        } else {
          this.hideWaveSurfer();
        }
      } catch (e) {
        this.hideWaveSurfer();
        this.toastServiceToast.openSnackBar(this.MESSAGE_STREAM_ERROR, 'Error');
        console.error(e);
      }

    }
  }

  private downloadBlobFile(url): Promise<BufferSource | Blob | string> {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await this.downloadService.downloadFile(url).toPromise();
        resolve(resp);

      } catch (e) {
        reject(e);

      }
    });
  }

  private hideWaveSurfer() {
    this.streamUrl = null;
    this.audioReady = true;
  }

  daysTooltip(){
    if(this.s3Lifecycle > 0)
      return this.s3Lifecycle+" days of past audio is available.";
    return "Loading...";
  }
}
